import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = {
            isShuffling: false,
            shuffleDeck: null,
        };
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.completed != this.props.completed && this.state.isShuffling) {
            this.stopShuffle();
        }
    }

    render() {
        return (
            <tarot-reading-shuffle>
                {this.renderButton()}
            </tarot-reading-shuffle>
        );
    }

    renderButton = () => {
        if (!this.props.completed) {
            return (
                <button
                    className='shuffle-button'
                    onClick={this.state.isShuffling ? this.stopShuffle : this.startShuffle}
                >
                    {this.state.isShuffling ? 'Stop Shuffle' : 'Shuffle Cards'}
                </button>
            );
        }

        return null;
    }

    stopShuffle = () => {
        window.clearInterval(this.state.shuffleDeck);

        this.setState({
            isShuffling: false,
            shuffleDeck: null,
        });

        [].map.call(document.querySelectorAll('tarot-reading-deck-card'), (el) => {
            el.classList.remove('shuffle');
        });

        this.props.shuffleDeck();
    }

    startShuffle = () => {
        this.props.trackEvent([
            'Click',
            `Readings_${this.props.upc}:Shuffle`,
        ]);

        this.setState({
            isShuffling: true,
            shuffleDeck: window.setInterval(this.shuffle, 100),
        });
    }

    shuffle = () => {
        if (this.props.spread) {
            const max = this.props.spread.length + 1;
            const math_random = (Math.random() * (max - 1)) + 1;
            const random = Math.floor(math_random);
            const el = document.querySelector('tarot-reading-deck-card:nth-of-type(' + random + ')');

            if (el) {
                el.classList.add('shuffle');
                setTimeout(() => {
                    el.classList.remove('shuffle');
                }, 500);
            }
        }
    }
}

const mapStateToProps = (state) => ({
    spread: state.spread,
    completed: state.product && state.product.teeup && state.product.teeup.fields
        && state.product.teeup.fields[2] && state.product.teeup.fields[2].positions
        && state.product.teeup.fields[2].positions.length > 0
        && state['tarot-reading'] && state['tarot-reading'].cards
        && state['tarot-reading'].cards.length === state.product.teeup.fields[2].positions.length,
});

const mapDispatchToProps = (dispatch) => ({
    shuffleDeck: () => dispatch({ type: 'tarot-reading:shuffle-deck' }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
